// Shared voice-file input handlers extracted byte-identical from Snippet/Snippet.vue and
// Stream.vue (SonarQube dedup); behavior unchanged. FullStreamReDesign.vue keeps its own
// copy (its user-visible error string differs), and Convest_Speech_To_Text stays in each
// component (messageRes is a string in Snippet but an array in Stream).
export default {
  methods: {
    Click_FileButtonVoid() {
      if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process != 'END' &&
        this.listMessage[this.listMessage.length - 1].status_Process != 'Stop') {
        return;
      }

      document.getElementById("inputFileVoid").click();
    },
    Chang_InputFileVoid(e) {
      const files = e.target.files;

      if ((files[0] == undefined)) {
        return;
      }
      if (files[0] !== undefined && (files[0].type == "audio/wav" || files[0].type == "audio/mpeg"
        || files[0].type == "audio/x-m4a")) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {

          let Output = {
            Status: true,
            NameFile: files[0].name,
            DataFile: files[0],
            manualContent: files[0].type
          }
          document.getElementById("inputFileVoid").value = "";
          this.Convest_Speech_To_Text(Output);
        });
      } else {
        let Output = {
          Status: false,
          NameFile: null,
          DataFile: null,
          manualContent: "รองรับไฟล์ MP3, WAV และ M4A เท่านั้น"
        }
        document.getElementById("inputFileVoid").value = "";

        this.Convest_Speech_To_Text(Output);
      }

    },
  },
};
